import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Text, Box, Icon } from '@qga/roo-ui/components';
import GoogleMapStaticImage from 'components/maps/GoogleMapStaticImage';

const PositionedBox = styled(Box)`
  position: absolute;
  display: inline-block;
  bottom: 0;
  right: 0;
  background-color: ${themeGet('colors.greys.mineShaft')};
  color: ${themeGet('colors.white')};
  padding: 2px 4px;
`;
PositionedBox.displayName = 'PositionedBox';

const GoogleMapStaticWithShowMap = ({ location, width, height }) => (
  <Box position="relative">
    <GoogleMapStaticImage location={location} width={width} height={height} />
    <PositionedBox>
      <Icon name="place" />
      <Text>Show Map</Text>
    </PositionedBox>
  </Box>
);

GoogleMapStaticWithShowMap.defaultProps = {
  width: 400,
  height: 400,
};

GoogleMapStaticWithShowMap.propTypes = {
  location: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default GoogleMapStaticWithShowMap;
